import { Cell, Checkbox } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';
import { type BaseRowData } from '@adv-frontend/data-provider';
import { type ColumnHeaderTemplateProps } from '@adv-frontend/grid';
import { type GridRow } from '../../lib/types';

export interface CellHeaderSelectProps<RowData extends BaseRowData = GridRow>
    extends ColumnHeaderTemplateProps<RowData>,
        TestProps {
    isDisabled?: boolean;
    disableSelectAll?: boolean;
}

export const CellHeaderSelect = <RowData extends BaseRowData = GridRow>({
    'data-testid': dataTestId = 'CellHeaderSelect',
    isDisabled = false,
    selectionManager,
    disableSelectAll = false,
}: CellHeaderSelectProps<RowData>) => {
    const isAllSelected = selectionManager?.useIsAllSelected?.() ?? false;

    return (
        <Cell data-testid={dataTestId} align="left" size="m" bottomPadding={false} type="Checkbox">
            {disableSelectAll ? null : (
                <Checkbox
                    aria-label="Выбрать все на странице"
                    size="xs"
                    isDisabled={isDisabled}
                    isSelected={isAllSelected}
                    onChange={selectionManager?.toggleAll}
                />
            )}
        </Cell>
    );
};
